var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgService(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Service"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Service",
    clipPath: "url(#clip-Service)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Iconly_Light-Outline_Setting",
    "data-name": "Iconly/Light-Outline/Setting",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Setting",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Combined-Shape",
    d: "M7.03,1A1.821,1.821,0,0,1,8.854,2.876a.731.731,0,0,0,.1.349.789.789,0,0,0,1.084.284,1.829,1.829,0,0,1,2.492.669l.427.739a.582.582,0,0,1,.029.059A1.83,1.83,0,0,1,12.3,7.4a.782.782,0,0,0-.29.288.8.8,0,0,0-.082.6.782.782,0,0,0,.37.481,1.817,1.817,0,0,1,.664,2.49l-.455.757a1.825,1.825,0,0,1-2.484.657.815.815,0,0,0-.382-.106h0a.792.792,0,0,0-.549.231.783.783,0,0,0-.231.562A1.828,1.828,0,0,1,7.03,15.189H6.172a1.826,1.826,0,0,1-1.824-1.823.737.737,0,0,0-.1-.364.784.784,0,0,0-1.079-.3A1.824,1.824,0,0,1,.671,12l-.428-.737A1.82,1.82,0,0,1,.907,8.785a.8.8,0,0,0,0-1.38A1.827,1.827,0,0,1,.242,4.917l.464-.762a1.822,1.822,0,0,1,2.48-.661.749.749,0,0,0,.378.108.8.8,0,0,0,.79-.785A1.815,1.815,0,0,1,6.172,1Zm0,1.027H6.172a.788.788,0,0,0-.79.794A1.833,1.833,0,0,1,3.559,4.628a1.767,1.767,0,0,1-.889-.248.8.8,0,0,0-1.079.3l-.464.762a.8.8,0,0,0,.3,1.075,1.824,1.824,0,0,1,0,3.158.791.791,0,0,0-.288,1.078l.432.745a.8.8,0,0,0,1.091.318,1.816,1.816,0,0,1,1.373-.181,1.827,1.827,0,0,1,1.1.85,1.755,1.755,0,0,1,.243.876.8.8,0,0,0,.8.8H7.03a.8.8,0,0,0,.8-.792,1.817,1.817,0,0,1,1.826-1.821,1.865,1.865,0,0,1,.878.242A.8.8,0,0,0,11.62,11.5l.455-.758a.791.791,0,0,0-.292-1.076,1.806,1.806,0,0,1-.85-1.108,1.829,1.829,0,0,1,.186-1.382,1.807,1.807,0,0,1,.665-.664.8.8,0,0,0,.286-1.081.382.382,0,0,1-.024-.047l-.4-.7A.8.8,0,0,0,10.557,4.4a1.817,1.817,0,0,1-2.484-.65,1.749,1.749,0,0,1-.246-.881.817.817,0,0,0-.225-.6A.8.8,0,0,0,7.03,2.028ZM6.6,5.776A2.319,2.319,0,1,1,4.286,8.1,2.322,2.322,0,0,1,6.6,5.776ZM6.6,6.8A1.291,1.291,0,1,0,7.9,8.1,1.293,1.293,0,0,0,6.6,6.8Z",
    transform: "translate(0 -1)",
    fill: "#a2a2a2",
    fillRule: "evenodd"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgService);
export default __webpack_public_path__ + "static/media/Service.eaf5d2668d4798f69ad95016a697e17a.svg";
export { ForwardRef as ReactComponent };